import { Controller } from "@hotwired/stimulus"

// 表の行の下に詳細行を開閉する。初めて開いたときに <template> の中身を差し込む。
// ApexCharts は非表示(display: none)の要素に描画すると幅 0 になるため、表示してから apex-chart コントローラーを接続させる。
// 使用例: SEO 追跡キーワードの表(control_panels/seo_dashboard/keywords)の順位推移
export default class extends Controller {
  static targets = ["button", "row", "content", "template"]

  toggle(event) {
    event.preventDefault()
    const opening = this.rowTarget.hidden
    this.rowTarget.hidden = !opening
    if (opening && this.hasTemplateTarget && this.contentTarget.childElementCount === 0) {
      this.contentTarget.appendChild(this.templateTarget.content.cloneNode(true))
    }
    this.buttonTargets.forEach((button) => button.setAttribute("aria-expanded", String(opening)))
  }
}
